Vue.component('customers', {
    props: ['user'],
    data: function(){
        return {
        }
    },
    methods: {
    }
});
